import React, { useEffect, useState, ReactNode, useContext } from 'react'
import { HotTable } from '@handsontable/react'
import { StyledCardContainer, StyledButton } from '../styles/styles'
import LiveTooltip from 'live/components/ui/tooltip'
import { canTriggerSync, canEditDvDData } from '../permission/Permissions'
import {
    runDvDStatusScheduler,
    triggerSync,
    getDataAndUpdateUI,
    classNames,
    showDeletePopup,
    getAndFilterIntervention,
    showReprocessMenu
} from '../functions/functions'
import { DvDDataContext } from '../context/DvDDataContext'
import { ReprocessModalForm } from '../components/ReprocessModalForm'
import i18n from 'live/services/i18n'
import DvDCopyDataForm from './DvDCopyDataForm'
import { getAllDatasetStats } from '../api'

export interface HeaderCardProps {
    selected: {
        asset: {
            id: string
            name: string
        }
    }
    title?: string
    about?: string
    addCollapse?: boolean
    children: ReactNode
    datasetType: string
}

export const HeaderContainer = (props: CardProps) => {
    const [collapsed, setCollapsed] = useState<boolean>(false)
    const datasetType = 'ds_day_depth'
    const { id, name } = props.selected?.asset
    const syncGetTimeInterval = 5000 //in milliseconds

    const [ticking, setTicking] = useState(true)
    const [count, setCount] = useState(0)
    const [showErrorsForStatus, setShowErrorsForStatus] = useState<boolean>(true)
    const {
        setTableData,
        unSavedData,
        setUnSavedData,
        setLoadingDataset,
        dataRowCount,
        lastNewDataSyncTime,
        setlastNewDataSyncTime,
        lastDataEditTime,
        setlastDataEditTime,
        isSyncForced,
        tableData,
        interventions,
        setInterventions,
        reprocessParameters,
        setReprocessParameters,
        setShowReprocessModal,
        showReprocessModal,
        loadingDataset,
        wellSyncStatus,
        setWellSyncStatus,
        showCopyDataForm,
        setShowCopyDataForm,
        copyMaxDate
    } = useContext(DvDDataContext)

    useEffect(() => {
        getDataAndUpdateUI(
            true,
            'Init',
            id,
            datasetType,
            setTableData,
            setUnSavedData,
            setlastDataEditTime,
            setLoadingDataset
        )
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => ticking && setCount(count + 1), syncGetTimeInterval)

        if (count >= 0) {
            runDvDStatusScheduler(
                id,
                setTicking,
                lastNewDataSyncTime,
                setlastNewDataSyncTime,
                unSavedData,
                setTableData,
                lastDataEditTime,
                setlastDataEditTime,
                setWellSyncStatus,
                setLoadingDataset,
                datasetType,
                showErrorsForStatus,
                setShowErrorsForStatus,
                setUnSavedData
            )
        }
        return () => clearTimeout(timer)
    }, [count, ticking])
    const record = { a: 1, b: 2 }

    return (
        <div>
            {showReprocessModal && (
                <ReprocessModalForm
                    setShow={setShowReprocessModal}
                    wellId={id}
                    title={i18n('DvD Data Reprocessing')}
                    value={reprocessParameters}
                    containsUnsavedData={unSavedData}
                ></ReprocessModalForm>
            )}
            {showCopyDataForm && (
                <DvDCopyDataForm
                    setShow={setShowCopyDataForm}
                    modalTitle=""
                    wellId={id}
                    getAllDatasetInfo={getAllDatasetStats}
                    maxDate={copyMaxDate}
                    setParentTableData={setTableData}
                ></DvDCopyDataForm>
            )}

            <StyledCardContainer
                title={props.title}
                subtitle={wellSyncStatus}
                collapsed={collapsed}
                toolTip={() => {
                    return (
                        <>
                            {props.about && props.about.length > 0 && (
                                <StyledButton className="trans">
                                    <LiveTooltip position={'left'} content={props.about}>
                                        <i className="fa fa-question-circle-o"></i>
                                    </LiveTooltip>
                                </StyledButton>
                            )}
                        </>
                    )
                }}
                renderControls={() => {
                    return (
                        <>
                            <StyledButton disabled={true} className="trans">
                                <i class="fa fa-table"></i> Available Row(s) : {dataRowCount}
                            </StyledButton>
                            {canEditDvDData() && (
                                <StyledButton
                                    className={classNames({
                                        danger: true
                                    })}
                                    onClick={() =>
                                        showDeletePopup(
                                            id,
                                            datasetType,
                                            setTableData,
                                            setLoadingDataset,
                                            setUnSavedData,
                                            setlastDataEditTime,
                                            unSavedData
                                        )
                                    }
                                >
                                    Clear
                                </StyledButton>
                            )}

                            {canTriggerSync() && (
                                <StyledButton
                                    onClick={() =>
                                        showReprocessMenu(
                                            interventions,
                                            setInterventions,
                                            tableData,
                                            id,
                                            setShowReprocessModal,
                                            reprocessParameters,
                                            setReprocessParameters
                                        )
                                    }
                                    className={classNames({
                                        solid: true
                                    })}
                                    disabled={isSyncForced}
                                >
                                    <i
                                        className={classNames({
                                            'far fa-sync-alt': true,
                                            'need-to-rotate': isSyncForced
                                        })}
                                    />
                                    On-demand Sync
                                </StyledButton>
                            )}
                            {props.addCollapse && (
                                <StyledButton onClick={() => setCollapsed(!collapsed)}>
                                    <i className={collapsed ? 'far fa-angle-up' : 'far fa-angle-down'} />
                                </StyledButton>
                            )}
                        </>
                    )
                }}
            >
                {props.children}
            </StyledCardContainer>
        </div>
    )
}
